/* ============================================================
   GRENADINE — Orthographe « Corrigez les fautes » (page Jeux, vue #orthographe)
   Chaque texte est écrit dans sa version CORRECTE (x) + la liste des fautes (m) :
     c = forme correcte (un ou plusieurs mots du texte, séparés par une espace)
     i = rang de l'occurrence si la forme apparaît plusieurs fois (0 = la première)
     w = forme fautive affichée au joueur
     s = 1 si la faute est montrée en rouge au niveau 2 (niveau 1 : tout en rouge, niveau 3 : rien)
     a = autres réponses acceptées (facultatif)
     r = règle expliquée en une ligne
   La version fautive est construite automatiquement.
   ============================================================ */
(function(){
  'use strict';

  var BANK = {
  /* ---------------- NIVEAU 1 « Bien » : 5–6 fautes, toutes en rouge ---------------- */
  1: [
    {id:'b1', t:'Le rendez-vous',
     x:"Samedi matin, Inès a pris rendez-vous au salon GRENADINE pour un brushing. Elle est arrivée à dix heures, un peu stressée. Sa coiffeuse lui a demandé où elle allait ensuite. « À un mariage, et je veux que tous les invités remarquent mes boucles ! » Ses amies l'ont trouvée magnifique.",
     m:[
      {c:'a', i:0, w:'à', r:"« a » est le verbe avoir (on peut dire « avait pris ») : pas d'accent."},
      {c:'arrivée', w:'arrivé', r:"Avec l'auxiliaire être, le participe passé s'accorde avec le sujet : elle est arrivée."},
      {c:'à', i:0, w:'a', r:"« à » est une préposition : on ne peut pas dire « avait dix heures »."},
      {c:'demandé', w:'demander', r:"Après « a », c'est un participe passé en -é (comme « a pris », pas « a prendre »)."},
      {c:'où', w:'ou', r:"« où » (avec accent) indique le lieu ; « ou » sans accent signifie « ou bien »."},
      {c:'tous', w:'tout', r:"« tous » s'accorde avec « les invités » (masculin pluriel)."}
     ]},
    {id:'b2', t:'Les boucles de Léa',
     x:"Léa a les cheveux bouclés depuis toujours. Quand elle était petite, elle les cachait sous un bonnet. Aujourd'hui, elle a décidé de les laisser respirer, et ses boucles sont devenues sa fierté. Quant à sa routine, elle tient en trois gestes : shampoing doux, masque et Spa Mist. Toute sa famille lui demande maintenant ses secrets.",
     m:[
      {c:'Quand', w:'Quant', r:"« quand » (avec d) marque le temps : on peut le remplacer par « lorsque »."},
      {c:'décidé', w:'décider', r:"Après l'auxiliaire « a », participe passé en -é (comme « a pris »)."},
      {c:'laisser', w:'laissé', r:"Après la préposition « de », le verbe reste à l'infinitif (comme « de les prendre »)."},
      {c:'devenues', w:'devenus', r:"Avec être, accord avec le sujet « ses boucles » : féminin pluriel."},
      {c:'Quant', w:'Quand', r:"« Quant à » (avec t) signifie « en ce qui concerne »."},
      {c:'Toute', w:'Tout', r:"« Toute » s'accorde avec « sa famille » (féminin singulier)."}
     ]},
    {id:'b3', t:'Le lissage de Chloé',
     x:"Chloé a enfin craqué pour un lissage brésilien chez GRENADINE. C'est une décision qu'elle attendait depuis des mois. Au bureau, ses collègues ne la reconnaissent plus : où sont passés ses frisottis ? Quand il pleut, elle sort sans parapluie et ses cheveux restent lisses. Elle leur conseille de venir l'essayer à Lyon.",
     m:[
      {c:'craqué', w:'craquer', r:"Après « a », participe passé en -é (comme « a pris », pas « a prendre »)."},
      {c:"C'est", w:"S'est", r:"« c'est » = cela est ; « s'est » ne s'emploie que devant un participe passé (elle s'est coiffée)."},
      {c:'où', w:'ou', r:"« où » (avec accent) indique le lieu ; « ou » sans accent = « ou bien »."},
      {c:'passés', w:'passé', r:"Avec être, accord avec le sujet « ses frisottis » : masculin pluriel."},
      {c:'Quand', w:'Quant', r:"« quand » (avec d) = lorsque ; « quant à » = en ce qui concerne."},
      {c:'leur', w:'leurs', r:"Devant un verbe, « leur » (= à elles) est un pronom invariable : jamais de s."}
     ]},
    {id:'b4', t:'Un samedi au salon',
     x:"Le samedi, le salon GRENADINE est plein à craquer. Les coiffeuses passent d'un fauteuil à l'autre et tous les sèche-cheveux tournent. Une cliente s'est endormie au bac pendant son massage crânien. Ses voisines se demandent si elles vont oser la réveiller. Où trouver un meilleur endroit pour se détendre ?",
     m:[
      {c:'à', i:0, w:'a', r:"« à » est une préposition (plein à craquer) ; « a » est le verbe avoir."},
      {c:'tous', w:'tout', r:"« tous » s'accorde avec « les sèche-cheveux » (masculin pluriel)."},
      {c:"s'est", w:"c'est", r:"« s'est » vient du verbe pronominal « s'endormir » ; « c'est » = cela est."},
      {c:'endormie', w:'endormi', r:"Avec être, accord avec le sujet « une cliente » : féminin."},
      {c:'oser', w:'osé', r:"Après « vont », le verbe reste à l'infinitif (comme « vont prendre »)."},
      {c:'Où', w:'Ou', r:"« Où » (avec accent) indique le lieu ; « ou » = ou bien."}
     ]},
    {id:'b5', t:'Le réflexe Spa Mist',
     x:"Quand on a les cheveux secs, on cherche toujours le bon geste. Chez GRENADINE, on vous conseille le Spa Mist : quelques pulvérisations sur les longueurs, et c'est tout. Vos pointes sont protégées et vos boucles restent souples toute la journée. Quant au parfum, nos clientes l'adorent. Elles nous disent qu'elles ne peuvent plus s'en passer.",
     m:[
      {c:'a', w:'à', r:"« on a » : verbe avoir (on peut dire « on avait ») : pas d'accent."},
      {c:"c'est", w:"s'est", r:"« c'est » = cela est ; « s'est » se place devant un participe passé."},
      {c:'protégées', w:'protégés', r:"Avec être, accord avec le sujet « vos pointes » : féminin pluriel."},
      {c:'toute', w:'tout', r:"« toute » s'accorde avec « la journée » (féminin singulier)."},
      {c:'Quant', w:'Quand', r:"« Quant à / quant au » (avec t) = en ce qui concerne."},
      {c:'passer', w:'passé', r:"Après « peuvent », le verbe reste à l'infinitif (comme « s'en prendre »)."}
     ]},
    {id:'b6', t:'Le diagnostic de Nana',
     x:"Avant votre premier rendez-vous, Nana vous pose quelques questions sur vos cheveux. Où les lavez-vous, à quelle fréquence, avec quels produits ? Grâce à vos réponses, elle peut ensuite proposer les soins adaptés. Les clientes qui ont testé son diagnostic sont toutes ravies. Leurs cheveux n'ont jamais été aussi bien traités.",
     m:[
      {c:'Où', w:'Ou', r:"« Où » (avec accent) indique le lieu ; « ou » sans accent = ou bien."},
      {c:'à', i:0, w:'a', r:"« à » préposition (à quelle fréquence) ; « a » = verbe avoir."},
      {c:'proposer', w:'proposé', r:"Après « peut », le verbe reste à l'infinitif (comme « peut prendre »)."},
      {c:'testé', w:'tester', r:"Après « ont », participe passé en -é (comme « ont pris »)."},
      {c:'toutes', w:'tout', r:"« toutes » se rapporte aux clientes : féminin pluriel."},
      {c:'Leurs', w:'Leur', r:"Devant un nom pluriel (cheveux), le possessif s'écrit « leurs »."}
     ]},
    {id:'b7', t:"La coupe d'été",
     x:"Cet été, Margot a décidé de couper ses longueurs. Elle hésitait entre un carré et une coupe plus courte. Sa coiffeuse lui a montré quelques photos, et elle a choisi le carré. Ses amies se sont exclamées en la voyant arriver. Elle a promis de leur donner l'adresse du salon.",
     m:[
      {c:'a', i:0, w:'à', r:"« a décidé » : verbe avoir (avait décidé), sans accent."},
      {c:'couper', w:'coupé', r:"Après la préposition « de », le verbe reste à l'infinitif (de prendre)."},
      {c:'montré', w:'montrer', r:"Après « a », participe passé en -é (comme « a pris »)."},
      {c:'a', i:2, w:'à', r:"« a choisi » : verbe avoir (avait choisi), sans accent."},
      {c:'exclamées', w:'exclamé', r:"Avec être, accord avec le sujet « ses amies » : féminin pluriel."},
      {c:'leur', w:'leurs', r:"Devant un verbe, « leur » (= à elles) est invariable."}
     ]},
    {id:'b8', t:'La routine du soir',
     x:"Tous les soirs, Jade démêle ses boucles avec ses doigts, puis elle les attache en ananas. Elle dort sur une taie en satin, où ses cheveux glissent sans frottement. Le matin, elle n'a plus qu'à les rafraîchir avec un peu d'eau. Quant aux nœuds, ils ont presque disparu. C'est simple et ça marche.",
     m:[
      {c:'Tous', w:'Tout', r:"« Tous » s'accorde avec « les soirs » (masculin pluriel)."},
      {c:'où', w:'ou', r:"« où » (avec accent) indique le lieu ; « ou » = ou bien."},
      {c:"n'a", w:"n'à", r:"« n'a » : verbe avoir (elle n'avait), sans accent."},
      {c:"qu'à", w:"qu'a", r:"« ne… plus qu'à » + infinitif : c'est la préposition « à »."},
      {c:'Quant', w:'Quand', r:"« Quant aux » (avec t) = en ce qui concerne."},
      {c:"C'est", w:"S'est", r:"« C'est » = cela est ; « s'est » se place devant un participe passé."}
     ]}
  ],

  /* ---------------- NIVEAU 2 « Très bien » : 6–8 fautes, la moitié en rouge ---------------- */
  2: [
    {id:'m1', t:'La couleur de Sarah',
     x:"Sarah rêvait de reflets châtain clair. Les mèches que sa coloriste lui a faites sont parfaites. Apparemment, ses amies lui demandent toutes l'adresse du salon. Quelle que soit la lumière, ses cheveux brillent. C'est sûr : elle reviendra chez GRENADINE. Elle est censée revenir dans six semaines, mais elle a déjà réservé.",
     m:[
      {c:'châtain clair', w:'châtains clairs', s:1, r:"Adjectif de couleur composé (châtain clair) : invariable."},
      {c:'faites', w:'fait', r:"Avec avoir, accord avec le COD placé avant (que = les mèches)."},
      {c:'Apparemment', w:'Apparement', s:1, r:"Adverbe formé sur « apparent » : apparemment, avec deux m."},
      {c:'Quelle que', w:'Quelque', s:1, r:"« Quel que » + être s'écrit en deux mots et s'accorde avec le sujet (la lumière)."},
      {c:'sûr', w:'sur', r:"« sûr » (certain) garde son accent circonflexe ; « sur » = dessus."},
      {c:'censée', w:'sensée', r:"« censé » = supposé ; « sensé » = qui a du bon sens."},
      {c:'déjà', w:'déja', r:"« déjà » prend deux accents : un aigu sur le é, un grave sur le à."}
     ]},
    {id:'m2', t:'Le salon qui a du cœur',
     x:"À Lyon, le salon GRENADINE vous attend tout près de chez vous. Votre fauteuil est prêt à vous accueillir. Nos coiffeuses, qui ont le cœur sur la main, vous chouchoutent davantage chaque année. Elles ont développé des soins sur mesure pour les cheveux auburn ou marron. Les masques que vous avez achetés sont là pour prolonger l'effet. Il serait insensé de s'en priver.",
     m:[
      {c:'près', w:'prêt', r:"« près de » = à côté de ; « prêt » = préparé."},
      {c:'prêt', w:'près', r:"« prêt à » = préparé pour ; « près de » = à côté de."},
      {c:'cœur', w:'chœur', s:1, a:['coeur'], r:"« cœur » : l'organe et les sentiments ; « chœur » : un groupe de chanteurs."},
      {c:'davantage', w:"d'avantage", s:1, r:"« davantage » (= plus) s'écrit en un seul mot."},
      {c:'développé', w:'dévelloppé', r:"« développer » : un seul l, deux p."},
      {c:'marron', w:'marrons', s:1, r:"Couleur issue d'un nom (le marron, le fruit) : invariable."},
      {c:'achetés', w:'acheté', r:"Avec avoir, accord avec le COD placé avant (que = les masques)."},
      {c:'là', w:'la', s:1, r:"« là » adverbe de lieu prend un accent grave."}
     ]},
    {id:'m3', t:'Le grand jour de Juliette',
     x:"Le jour de son mariage, Juliette avait les mains moites. Sa coiffeuse l'a rassurée : « Tout est prêt, vos cheveux sont magnifiques. » Les épingles qu'elle avait préparées étaient parfaitement rangées. Quelques mèches blond vénitien encadraient son visage. Apparemment, même le photographe était ému. Juliette a dû retenir ses larmes au moment de découvrir son chignon.",
     m:[
      {c:'rassurée', w:'rassuré', r:"Avec avoir, accord avec le COD placé avant (l' = Juliette)."},
      {c:'prêt', w:'près', s:1, r:"« prêt » = préparé ; « près » = proche."},
      {c:'préparées', w:'préparé', r:"Avec avoir, accord avec le COD placé avant (qu' = les épingles)."},
      {c:'Quelques', w:'Quelque', r:"« Quelques » (= plusieurs) s'accorde avec « mèches »."},
      {c:'blond vénitien', w:'blonds vénitiens', s:1, r:"Couleur composée (blond vénitien) : invariable."},
      {c:'Apparemment', w:'Apparament', s:1, r:"Formé sur « apparent » : apparemment, -emment avec deux m."},
      {c:'dû', w:'du', r:"« dû » (participe passé de devoir) prend un accent circonflexe."}
     ]},
    {id:'m4', t:'La mission de Hugo',
     x:"Lundi matin, Hugo a une tâche délicate : rattraper une couleur ratée ailleurs. Sa cliente a des reflets orange sur des cheveux châtain foncé. Il l'a appelée la veille pour lui expliquer son plan. Les mèches qu'il a reprises une à une sont maintenant uniformes. C'était un vrai casse-tête, mais le résultat est là. Ravie, sa cliente est repartie le cœur léger.",
     m:[
      {c:'tâche', w:'tache', s:1, r:"« tâche » (travail) prend un accent ; « tache » = salissure."},
      {c:'rattraper', w:'rattrapper', r:"« rattraper » : deux t, mais un seul p (comme « attraper »)."},
      {c:'orange', w:'oranges', s:1, r:"Couleur issue d'un nom (l'orange, le fruit) : invariable."},
      {c:'châtain foncé', w:'châtains foncés', r:"Couleur composée (châtain foncé) : invariable."},
      {c:'appelée', w:'appelé', r:"Avec avoir, accord avec le COD placé avant (l' = la cliente)."},
      {c:'reprises', w:'repris', r:"Avec avoir, accord avec le COD placé avant (qu' = les mèches)."},
      {c:'là', w:'la', s:1, r:"« là » adverbe de lieu prend un accent grave."},
      {c:'cœur', w:'chœur', s:1, a:['coeur'], r:"« cœur » : l'organe et les sentiments ; « chœur » : des chanteurs."}
     ]},
    {id:'m5', t:'Le lissage, mode d\'emploi',
     x:"Vous êtes tentée par un lissage brésilien ? Quel que soit votre type de cheveux, le soin est adapté après un diagnostic. Juste après, vous êtes censée éviter les élastiques et les barrettes. Les mèches que vous aurez attachées trop tôt garderont une marque. Ensuite, vos cheveux resteront lisses bien plus longtemps que vous ne l'imaginez. C'est sûr, vous en voudrez davantage.",
     m:[
      {c:'Quel que', w:'Quelque', s:1, r:"« Quel que » + être : deux mots, accordé avec le sujet (votre type, masculin)."},
      {c:'censée', w:'sensée', r:"« censé » = supposé ; « sensé » = raisonnable."},
      {c:'attachées', w:'attaché', r:"Avec avoir, accord avec le COD placé avant (que = les mèches)."},
      {c:'tôt', w:'tot', r:"« tôt » prend un accent circonflexe."},
      {c:'sûr', w:'sur', s:1, r:"« sûr » (certain) prend un accent ; « sur » = dessus."},
      {c:'davantage', w:"d'avantage", s:1, r:"« davantage » (= plus) s'écrit en un seul mot."}
     ]},
    {id:'m6', t:'Le jeudi des habituées',
     x:"Le mercredi, le salon est fermé ; le jeudi, les habituées du quartier arrivent dès l'ouverture. Elles viennent avec leurs belles-sœurs, prêtes à tout pour une mise en plis. Ces dames ont les cheveux poivre et sel, et elles en sont fières. Apparemment, les potins qu'on échange au bac sont meilleurs que ceux du marché. Leur sujet préféré ? Les chefs-d'œuvre que leurs coiffeuses ont réalisés.",
     m:[
      {c:'dès', w:'des', r:"« dès » (= à partir de) prend un accent grave."},
      {c:'belles-sœurs', w:'belle-sœurs', s:1, a:['belles-soeurs'], r:"Nom composé adjectif + nom : les deux prennent la marque du pluriel."},
      {c:'prêtes', w:'près', r:"« prêtes à » = préparées à ; « près de » = à côté de."},
      {c:'poivre et sel', w:'poivres et sels', s:1, r:"Couleur composée (poivre et sel) : invariable."},
      {c:'Apparemment', w:'Apparament', r:"Formé sur « apparent » : apparemment, -emment avec deux m."},
      {c:"chefs-d'œuvre", w:"chef-d'œuvres", s:1, a:["chefs-d'oeuvre"], r:"Nom + complément : seul le premier nom se met au pluriel (des chefs-d'œuvre)."},
      {c:'réalisés', w:'réalisé', r:"Avec avoir, accord avec le COD placé avant (que = les chefs-d'œuvre)."}
     ]},
    {id:'m7', t:'Thomas ose le changement',
     x:"Après des mois d'hésitation, Thomas était enfin mûr pour un changement. Il a appelé le salon un mardi et a obtenu un créneau le jour même. Sa coiffeuse a étudié les photos qu'il avait apportées, puis lui a proposé un dégradé plus court sur les côtés. Ses cheveux gris argent ont été sublimés par un gloss. Il a dû admettre qu'il aurait dû venir plus tôt.",
     m:[
      {c:'mûr', w:'mur', s:1, r:"« mûr » (prêt, à point) garde son accent circonflexe ; « mur » = paroi."},
      {c:'appelé', w:'appellé', s:1, r:"« appeler » ne double le l que devant un e muet (il appelle) : appelé."},
      {c:'créneau', w:'crénau', r:"« créneau » s'écrit avec -eau."},
      {c:'apportées', w:'apporté', r:"Avec avoir, accord avec le COD placé avant (qu' = les photos)."},
      {c:'côtés', w:'cotés', r:"« côté » (le flanc) prend un accent circonflexe ; « coté » = noté."},
      {c:'gris argent', w:'gris argents', s:1, r:"Couleur composée (gris argent) : invariable."},
      {c:'dû', i:0, w:'du', r:"« dû » (participe passé de devoir) prend un accent circonflexe."}
     ]},
    {id:'m8', t:'Une tache de couleur',
     x:"Oups : une tache de coloration sur le col de votre chemisier ! Pas de panique, nous sommes là pour ça. Notre tâche du jour : vous rendre le sourire. Quelles que soient vos questions, n'hésitez pas à nous appeler. Les conseils que nous vous avons donnés valent pour les cheveux bruns comme pour les cheveux bleu nuit.",
     m:[
      {c:'tache', w:'tâche', s:1, r:"« tache » (sans accent) = salissure ; « tâche » = travail."},
      {c:'là', w:'la', r:"« là » adverbe de lieu prend un accent grave."},
      {c:'tâche', w:'tache', r:"« tâche » (travail) prend un accent circonflexe."},
      {c:'Quelles que', w:'Quelque', s:1, r:"« Quel que » + être : deux mots, accordé avec le sujet (vos questions)."},
      {c:'appeler', w:'appeller', r:"« appeler » : un seul l à l'infinitif (deux l seulement devant un e muet)."},
      {c:'donnés', w:'donné', r:"Avec avoir, accord avec le COD placé avant (que = les conseils)."},
      {c:'bleu nuit', w:'bleus nuit', s:1, r:"Couleur composée (bleu nuit) : invariable."}
     ]}
  ],

  /* ---------------- NIVEAU 3 « Expert » : 7–10 fautes, toutes cachées ---------------- */
  3: [
    {id:'e1', t:'Les sœurs Martin',
     x:"Ce samedi-là, les sœurs Martin se sont fait couper les cheveux chez GRENADINE. Aussitôt arrivées, elles se sont lavé les mains et se sont installées au bac. Bien qu'elles soient venues sans rendez-vous, l'équipe leur a trouvé deux créneaux. Elles se sont souri dans le miroir, toutes contentes du résultat. La plus jeune s'est fait faire une frange ; l'aînée a seulement rafraîchi ses quatre-vingts centimètres de longueur. Elles sont reparties deux heures et demie plus tard.",
     m:[
      {c:'fait', i:0, w:'faites', r:"« fait » suivi d'un infinitif reste toujours invariable (se sont fait couper)."},
      {c:'Aussitôt', w:'Aussi tôt', r:"« aussitôt » (= dès que) en un mot ; « aussi tôt » s'oppose à « aussi tard »."},
      {c:'lavé', w:'lavées', r:"Pronominal avec un COD placé après (les mains) : pas d'accord."},
      {c:'installées', w:'installé', r:"« s'installer » : « se » est COD, accord avec le sujet (elles)."},
      {c:'soient', w:'sont', r:"« Bien que » est toujours suivi du subjonctif."},
      {c:'leur', w:'leurs', r:"Devant un verbe, le pronom « leur » (= à elles) est invariable."},
      {c:'souri', w:'souries', r:"« se sourire » : « se » est COI (sourire à quelqu'un), participe invariable."},
      {c:'toutes', w:'tout', r:"Devant un adjectif féminin commençant par une consonne, « tout » s'accorde : toutes contentes."},
      {c:'quatre-vingts', w:'quatre-vingt', a:['quatre vingts'], r:"« quatre-vingts » prend un s quand il n'est pas suivi d'un autre nombre."},
      {c:'demie', w:'demi', r:"Après le nom, « et demie » s'accorde en genre avec lui (deux heures et demie)."}
     ]},
    {id:'e2', t:'Le courrier du salon',
     x:"Chère cliente, vous trouverez votre fiche conseil ci-jointe. Quoi que vous fassiez cet été, protégez vos longueurs de la chaleur. Tous vos produits conviennent, excepté les shampoings trop décapants. Nous avons accueilli quatre-vingt-deux nouvelles clientes ce mois-ci et nous en attendons deux cents de plus. Nos coiffeuses elles-mêmes n'en reviennent pas ! Même les plus pressées prennent le temps d'un massage. À très bientôt chez GRENADINE !",
     m:[
      {c:'ci-jointe', w:'ci-joint', r:"Placé après le nom (votre fiche), « ci-joint » s'accorde : ci-jointe."},
      {c:'Quoi que', w:'Quoique', r:"« quoi que » en deux mots = quelle que soit la chose que ; « quoique » = bien que."},
      {c:'fassiez', w:'faites', r:"« Quoi que » est suivi du subjonctif : quoi que vous fassiez."},
      {c:'excepté', w:'exceptés', r:"Placé devant le nom, « excepté » est une préposition invariable."},
      {c:'quatre-vingt-deux', w:'quatre-vingts-deux', r:"« quatre-vingt » perd son s quand il est suivi d'un autre nombre."},
      {c:'cents', w:'cent', r:"« cent » multiplié prend un s s'il n'est suivi d'aucun nombre : deux cents."},
      {c:'elles-mêmes', w:'elles-même', r:"« même » s'accorde avec le pronom qu'il renforce : elles-mêmes."},
      {c:'Même', w:'Mêmes', r:"Ici « même » est un adverbe (= aussi, jusqu'à) : invariable."}
     ]},
    {id:'e3', t:"Manon avant l'été",
     x:"Juin approchait et Manon rêvait de boucles toutes belles pour les vacances. Bien qu'elle ait peu de temps, elle s'est rendu compte qu'un soin s'imposait. Le jour du rendez-vous, elle s'est levée aussi tôt qu'un jour de travail. Les huiles qu'elle s'était achetées en ligne ne lui convenaient pas. Sa coiffeuse lui a conseillé un masque et une demi-dose de crème. Manon s'est sentie toute légère en sortant. Le soir, ses amies lui ont demandé l'adresse et elle la leur a donnée.",
     m:[
      {c:'toutes', w:'tout', r:"Devant un adjectif féminin commençant par une consonne, « tout » s'accorde : toutes belles."},
      {c:'ait', w:'a', r:"« Bien que » est suivi du subjonctif : bien qu'elle ait."},
      {c:'rendu', w:'rendue', r:"« se rendre compte » : participe invariable (« compte » est le COD)."},
      {c:'levée', w:'levé', r:"« se lever » : « se » est COD, accord avec le sujet (elle)."},
      {c:'aussi tôt', w:'aussitôt', r:"« aussi tôt » (en deux mots) s'oppose à « aussi tard » ; « aussitôt » = immédiatement."},
      {c:'achetées', w:'acheté', r:"« s'acheter » : « se » est COI ; accord avec le COD placé avant (qu' = les huiles)."},
      {c:'demi-dose', w:'demie-dose', r:"Devant le nom, « demi » est invariable et suivi d'un trait d'union."},
      {c:'toute', w:'tout', r:"Devant un adjectif féminin commençant par une consonne, « tout » s'accorde : toute légère."},
      {c:'leur', w:'leurs', r:"Devant un verbe, le pronom « leur » (= à elles) est invariable."},
      {c:'donnée', w:'donné', r:"Avec avoir, accord avec le COD placé avant (la = l'adresse)."}
     ]},
    {id:'e4', t:'Le cours de brushing',
     x:"Mardi soir, GRENADINE a organisé un cours de brushing pour vingt et une clientes. Elles se sont succédé devant le grand miroir pendant deux heures et demie. Quoiqu'un peu intimidées au début, elles se sont vite prises au jeu. Les brosses qu'elles se sont passées de main en main ont fait le tour du salon. Après qu'elles sont parties, l'équipe a ramassé deux cents épingles. Ce fut une soirée tout à fait réussie. Les coiffeuses se sont promis de recommencer.",
     m:[
      {c:'une', i:0, w:'un', r:"« vingt et une clientes » : « un » s'accorde avec un nom féminin."},
      {c:'succédé', w:'succédées', r:"« se succéder » : « se » est COI (succéder à), participe invariable."},
      {c:'demie', w:'demi', r:"Après le nom, « et demie » s'accorde en genre avec lui (deux heures et demie)."},
      {c:"Quoiqu'un", w:"Quoi qu'un", r:"« quoique » (= bien que) s'écrit en un seul mot."},
      {c:'prises', w:'pris', r:"« se prendre au jeu » : accord avec le sujet (elles)."},
      {c:'passées', w:'passé', r:"« se passer quelque chose » : accord avec le COD placé avant (qu' = les brosses)."},
      {c:'sont', i:3, w:'soient', r:"« Après que » est suivi de l'indicatif (le fait est accompli)."},
      {c:'cents', w:'cent', r:"« cent » multiplié prend un s s'il n'est suivi d'aucun nombre : deux cents."},
      {c:'promis', w:'promises', r:"« se promettre de » : « se » est COI, participe invariable."}
     ]},
    {id:'e5', t:'La cliente pressée',
     x:"Mme Duval est arrivée à une heure et demie, pressée comme jamais. Bien qu'elle ait un rendez-vous important, elle a pris le temps d'un shampoing. Les mèches que sa coiffeuse a fait boucler tiendront jusqu'au soir. Aussitôt coiffée, Mme Duval s'est regardée dans le miroir et s'est trouvée toute belle. Ses collègues elles-mêmes lui ont demandé quel était son secret. Elle leur a répondu en riant : « Mon salon, c'est GRENADINE ! »",
     m:[
      {c:'demie', w:'demi', r:"Après le nom, « et demie » s'accorde en genre avec lui (une heure et demie)."},
      {c:'ait', w:'a', r:"« Bien que » est suivi du subjonctif : bien qu'elle ait."},
      {c:'fait', w:'faites', r:"« fait » suivi d'un infinitif est toujours invariable."},
      {c:'Aussitôt', w:'Aussi tôt', r:"« aussitôt » (= dès que) en un mot ; « aussi tôt » s'oppose à « aussi tard »."},
      {c:'regardée', w:'regardé', r:"« se regarder » : « se » est COD, accord avec le sujet."},
      {c:'trouvée', w:'trouvé', r:"« se trouver belle » : « se » est COD, accord avec le sujet."},
      {c:'toute', w:'tout', r:"Devant un adjectif féminin commençant par une consonne, « tout » s'accorde : toute belle."},
      {c:'elles-mêmes', w:'elles-même', r:"« même » s'accorde avec le pronom qu'il renforce : elles-mêmes."},
      {c:'quel', w:"qu'elle", r:"« quel » (interrogatif) s'accorde avec « secret » ; « qu'elle » = que + elle."},
      {c:'leur', w:'leurs', r:"Devant un verbe, le pronom « leur » (= à elles) est invariable."}
     ]},
    {id:'e6', t:'Les jumelles',
     x:"Les jumelles Léna et Zoé ont fêté leurs vingt et un ans au salon. Elles se sont fait faire des tresses identiques, puis elles se sont maquillées l'une l'autre. Quelle que soit leur coiffure, on ne les distingue jamais. Pendant leurs vacances, elles se sont téléphoné tous les jours. Les photos qu'elles se sont envoyées ont fait rire toute l'équipe. Elles reviendront pour leurs quatre-vingts ans, ont-elles promis.",
     m:[
      {c:'leurs', i:0, w:'leur', r:"Possessif devant un nom pluriel (ans) : « leurs »."},
      {c:'fait', i:0, w:'faites', r:"« fait » suivi d'un infinitif reste toujours invariable."},
      {c:'maquillées', w:'maquillé', r:"« se maquiller l'une l'autre » : « se » est COD, accord avec le sujet."},
      {c:'Quelle que', w:'Quelque', r:"« Quel que » + être : deux mots, accordé avec le sujet (leur coiffure)."},
      {c:'téléphoné', w:'téléphonées', r:"« se téléphoner » : « se » est COI (téléphoner à), participe invariable."},
      {c:'envoyées', w:'envoyé', r:"« se » est COI ; accord avec le COD placé avant (qu' = les photos)."},
      {c:'quatre-vingts', w:'quatre-vingt', a:['quatre vingts'], r:"« quatre-vingts » prend un s quand il n'est pas suivi d'un autre nombre."},
      {c:'ont-elles', w:'ont-t-elles', r:"Le t euphonique ne s'ajoute qu'entre deux voyelles : a-t-elle, mais ont-elles."}
     ]},
    {id:'e7', t:'Clara, nouvelle Lyonnaise',
     x:"Clara vit à Lyon depuis quatre-vingt-dix jours. Une collègue lui a recommandé GRENADINE ; elle y est allée le samedi suivant. Bien qu'elle craigne les ciseaux, elle a accepté de couper cinq centimètres. Ses boucles, qu'elle avait toujours trouvées trop sèches, se sont mises à briller. Quoi qu'en disent ses sœurs, elle ne changera plus de salon. Elle s'est promis d'y emmener ses cousines, qui hésitent elles-mêmes à changer. « Ci-joint, une photo du résultat », a-t-elle écrit à sa collègue.",
     m:[
      {c:'quatre-vingt-dix', w:'quatre-vingts-dix', r:"« quatre-vingt » perd son s quand il est suivi d'un autre nombre."},
      {c:'allée', w:'allé', r:"Avec être, accord avec le sujet (elle)."},
      {c:'craigne', w:'craint', r:"« Bien que » est suivi du subjonctif : qu'elle craigne."},
      {c:'trouvées', w:'trouvé', r:"Avec avoir, accord avec le COD placé avant (qu' = ses boucles)."},
      {c:'mises', w:'mis', r:"« se mettre à » : accord avec le sujet (ses boucles)."},
      {c:"Quoi qu'en", w:"Quoiqu'en", r:"« quoi que » (= quelle que soit la chose que) s'écrit ici en deux mots."},
      {c:'promis', w:'promise', r:"« se promettre de » : « se » est COI, participe invariable."},
      {c:'elles-mêmes', w:'elles-même', r:"« même » s'accorde avec le pronom qu'il renforce : elles-mêmes."},
      {c:'Ci-joint', w:'Ci-jointe', r:"En tête de phrase, « ci-joint » est invariable."},
      {c:'a-t-elle', w:"a-t'elle", r:"Le t euphonique s'écrit entre deux traits d'union : a-t-elle."}
     ]},
    {id:'e8', t:'Les longueurs de Mila',
     x:"Mila n'avait pas coupé ses cheveux depuis mille jours, et ses pointes en avaient souffert. Les quelques centimètres qu'elle a dû sacrifier l'ont fait hésiter. Sa coiffeuse et elle se sont mises d'accord pour une coupe tout en douceur. Une fois coiffée, Mila s'est trouvée toute changée. Elle a envoyé deux cent vingt photos à ses amies, qui se sont toutes extasiées. Quoique ravie, elle compte déjà les jours avant son prochain soin.",
     m:[
      {c:'mille', w:'milles', r:"« mille » (le nombre) est toujours invariable."},
      {c:'quelques', w:'quelque', r:"« quelques » (= plusieurs) s'accorde avec « centimètres »."},
      {c:'dû', w:'dus', r:"« dû » suivi d'un infinitif (sacrifier) : le COD dépend de l'infinitif, participe invariable."},
      {c:'mises', w:'mis', r:"« se mettre d'accord » : accord avec le sujet (sa coiffeuse et elle)."},
      {c:'toute', w:'tout', r:"Devant un adjectif féminin commençant par une consonne, « tout » s'accorde : toute changée."},
      {c:'cent', w:'cents', r:"« cent » suivi d'un autre nombre (vingt) ne prend pas de s."},
      {c:'extasiées', w:'extasié', r:"« s'extasier » (toujours pronominal) : accord avec le sujet."},
      {c:'Quoique', w:'Quoi que', r:"« quoique » (= bien que) s'écrit en un seul mot."}
     ]}
  ]};

  var LEVELS = {
    1:{name:'Bien', desc:'Les fautes sont en rouge : à vous de les corriger.'},
    2:{name:'Très bien', desc:'La moitié des fautes est en rouge, les autres se cachent.'},
    3:{name:'Expert', desc:'Aucune faute en rouge : touchez les mots suspects.'}
  };
  var MAX_HINTS = 2, BONUS = 2, LS_KEY = 'gj-ortho-v1';

  /* ---------- moteur (testable sans DOM) ---------- */
  var WORD_RE = /[0-9A-Za-zÀ-ÖØ-öø-ÿŒœÆæ'’-]+/g;

  function tokenize(s){
    var out=[], last=0, mt;
    WORD_RE.lastIndex=0;
    while((mt=WORD_RE.exec(s))){
      if(mt.index>last) out.push({w:false, s:s.slice(last,mt.index)});
      out.push({w:true, s:mt[0]});
      last=mt.index+mt[0].length;
    }
    if(last<s.length) out.push({w:false, s:s.slice(last)});
    return out;
  }

  function norm(s){
    return String(s==null?'':s).normalize('NFC').replace(/[’‘`´]/g,"'").replace(/œ/g,'oe').replace(/Œ/g,'OE').replace(/æ/g,'ae').replace(/Æ/g,'AE')
      .replace(/\s+/g,' ').trim().toLowerCase();
  }

  /* Trouve les positions (index de segment de départ) de la forme c dans les segments */
  function findAll(segs, c){
    var parts=c.split(' '), res=[];
    for(var k=0;k<segs.length;k++){
      if(!segs[k].w || segs[k].s!==parts[0]) continue;
      var ok=true, j=k;
      for(var p=1;p<parts.length;p++){
        if(!segs[j+1] || segs[j+1].w || segs[j+1].s!==' ' || !segs[j+2] || !segs[j+2].w || segs[j+2].s!==parts[p]){ ok=false; break; }
        j+=2;
      }
      if(ok) res.push({start:k, end:j});
    }
    return res;
  }

  /* Construit les unités du texte : {k:'p', s} ponctuation ; {k:'w', o} mot ; {k:'m', o, w, mi} faute */
  function build(text){
    var segs=tokenize(text.x), starts={}, errors=[];
    text.m.forEach(function(m, mi){
      var all=findAll(segs, m.c), idx=m.i||0;
      if(!all.length) errors.push('introuvable : '+m.c);
      else if(m.i===undefined && all.length>1) errors.push('ambigu (ajouter i) : '+m.c);
      else if(!all[idx]) errors.push('occurrence absente : '+m.c+' #'+idx);
      else if(starts[all[idx].start]) errors.push('chevauchement : '+m.c);
      else starts[all[idx].start]={mi:mi, end:all[idx].end};
    });
    var units=[], k=0;
    while(k<segs.length){
      var st=starts[k];
      if(st){
        var m=text.m[st.mi];
        units.push({k:'m', o:m.c, w:m.w, mi:st.mi});
        k=st.end+1;
      } else {
        units.push(segs[k].w ? {k:'w', o:segs[k].s} : {k:'p', s:segs[k].s});
        k++;
      }
    }
    var faulty=units.map(function(u){ return u.k==='p'?u.s:(u.k==='m'?u.w:u.o); }).join('');
    var correct=units.map(function(u){ return u.k==='p'?u.s:u.o; }).join('');
    return {units:units, faulty:faulty, correct:correct, errors:errors};
  }

  function accepted(m){ return [m.c].concat(m.a||[]).map(norm); }
  function isShown(m, level){ return level===1 ? true : level===3 ? false : !!m.s; }

  var API = {BANK:BANK, LEVELS:LEVELS, build:build, norm:norm, tokenize:tokenize, accepted:accepted, isShown:isShown};
  if(typeof module!=='undefined' && module.exports){ module.exports=API; return; }
  if(typeof window!=='undefined') window.GJOrtho=API;
  if(typeof document==='undefined') return;

  /* ---------- interface ---------- */
  var app=document.getElementById('or-app'); if(!app) return;

  function loadStore(){
    var o=null;
    try{ o=JSON.parse(window.localStorage.getItem(LS_KEY)||'null'); }catch(e){}
    if(!o || typeof o!=='object') o={};
    if(!o.best || typeof o.best!=='object') o.best={};
    if(!o.seen || typeof o.seen!=='object') o.seen={};
    return o;
  }
  function saveStore(){ try{ window.localStorage.setItem(LS_KEY, JSON.stringify(ST)); }catch(e){} }
  var ST=loadStore();

  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function pretty(s){ return esc(String(s).replace(/'/g,'’')); }
  /* ponctuation : espaces insécables avant ; : ! ? » et après « (pas de « ? » orphelin en début de ligne) */
  function punct(s){ return pretty(String(s).replace(/ ([;:!?»])/g,'\u00a0$1').replace(/« /g,'«\u00a0')); }
  function pts(n){ return n+(n>1?' pts':' pt'); }
  function plural(n, one, many){ return n+' '+(n>1?many:one); }

  var G=null; /* partie en cours */

  app.innerHTML =
    '<div class="or-screen" id="or-pick" hidden>'+
      '<p class="or-label">Choisissez votre niveau</p>'+
      '<div class="or-levels">'+[1,2,3].map(function(l){
        return '<button type="button" class="or-lvcard" data-lv="'+l+'">'+
          '<span class="or-lv-n">Niveau '+l+'</span>'+
          '<span class="or-lv-name">'+LEVELS[l].name+'</span>'+
          '<span class="or-lv-desc">'+LEVELS[l].desc+'</span>'+
          '<span class="or-lv-best" data-best="'+l+'"></span></button>';
      }).join('')+'</div>'+
    '</div>'+
    '<div class="or-screen" id="or-play" hidden>'+
      '<div class="or-top"><p class="or-label" id="or-lvlabel"></p><p class="or-count" id="or-count" aria-live="polite"></p></div>'+
      '<div class="or-paper" id="or-paper">'+
        '<p class="or-head">Corrigez les fautes</p>'+
        '<p class="or-ttl" id="or-ttl"></p>'+
        '<div class="or-text" id="or-text"></div>'+
      '</div>'+
      '<p class="or-toast" id="or-toast" role="status" aria-live="polite"></p>'+
      '<div class="or-actions" id="or-actions">'+
        '<button type="button" class="or-btn or-btn--dark" data-act="check">Vérifier</button>'+
        '<button type="button" class="or-btn or-btn--pink" data-act="hint" id="or-hint">Indice</button>'+
        '<button type="button" class="or-btn or-btn--soft" data-act="new">Nouveau texte</button>'+
        '<button type="button" class="or-btn or-btn--soft" data-act="level">Changer de niveau</button>'+
      '</div>'+
      '<div class="or-result" id="or-result" hidden></div>'+
    '</div>';

  /* feuille de saisie (ajoutée au body pour un position:fixed fiable) */
  var sheetRoot=document.createElement('div');
  sheetRoot.id='or-sheet-root';
  sheetRoot.hidden=true;
  sheetRoot.innerHTML=
    '<div class="or-sheet-bg" data-close></div>'+
    '<div class="or-sheet" role="dialog" aria-modal="true" aria-labelledby="or-sheet-t">'+
      '<p class="or-label" id="or-sheet-t">Corriger le mot</p>'+
      '<p class="or-sheet-orig" id="or-sheet-orig"></p>'+
      '<form id="or-sheet-form" autocomplete="off">'+
        '<input class="or-input" id="or-input" type="text" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="done" aria-label="Votre correction">'+
        '<div class="or-sheet-btns">'+
          '<button type="button" class="or-btn or-btn--soft" data-close>Annuler</button>'+
          '<button type="submit" class="or-btn or-btn--dark">Valider</button>'+
        '</div>'+
        '<button type="button" class="or-reset" id="or-reset">Remettre le mot d’origine</button>'+
      '</form>'+
    '</div>';
  document.body.appendChild(sheetRoot);

  var $=function(id){ return document.getElementById(id); };
  var pickEl=$('or-pick'), playEl=$('or-play'), textEl=$('or-text'), countEl=$('or-count'), toastEl=$('or-toast'),
      resultEl=$('or-result'), hintBtn=$('or-hint'), actionsEl=$('or-actions'),
      input=$('or-input'), sheetOrig=$('or-sheet-orig'), sheetForm=$('or-sheet-form'), resetBtn=$('or-reset'), sheet=sheetRoot.querySelector('.or-sheet');

  function showPick(){
    [1,2,3].forEach(function(l){
      var el=app.querySelector('[data-best="'+l+'"]');
      el.textContent = ST.best[l]!=null ? 'Record : '+pts(ST.best[l]) : '';
    });
    playEl.hidden=true; pickEl.hidden=false;
  }

  function pickText(level){
    var list=BANK[level], seen=(ST.seen[level]||[]).filter(function(id){ return list.some(function(t){return t.id===id;}); });
    var pool=list.filter(function(t){ return seen.indexOf(t.id)<0; });
    if(!pool.length){ seen=G&&G.level===level?[G.text.id]:[]; pool=list.filter(function(t){ return seen.indexOf(t.id)<0; }); }
    var t=pool[Math.floor(Math.random()*pool.length)];
    seen.push(t.id); ST.seen[level]=seen; saveStore();
    return t;
  }

  function start(level){
    var t=pickText(level), b=build(t);
    G={level:level, text:t, units:b.units, ans:{}, hints:0, checked:false};
    ST.lv=level; saveStore();
    $('or-lvlabel').textContent='Niveau '+level+' · '+LEVELS[level].name;
    $('or-ttl').textContent=t.t.replace(/'/g,'’');
    resultEl.hidden=true; resultEl.innerHTML='';
    actionsEl.classList.remove('is-done');
    toast('');
    pickEl.hidden=true; playEl.hidden=false;
    renderText(); updateCount();
  }

  function tappable(u){
    if(G.checked || u.k==='p') return false;
    return G.level===1 ? u.k==='m' : true;
  }
  function curText(i){ var u=G.units[i]; return G.ans[i]!=null ? G.ans[i] : (u.k==='m'?u.w:u.o); }

  function renderText(){
    var html='';
    G.units.forEach(function(u, i){
      if(u.k==='p'){ html+=punct(u.s); return; }
      var m=u.k==='m'?G.text.m[u.mi]:null;
      var cls=['or-w'];
      if(!G.checked){
        if(tappable(u)) cls.push('or-tap');
        if(m && isShown(m,G.level) && G.ans[i]==null) cls.push('or-red');
        if(G.ans[i]!=null) cls.push('or-ed');
        html+=wordSpans(curText(i), i, cls, tappable(u));
        return;
      }
      /* après vérification */
      if(m){
        var ok=accepted(m).indexOf(norm(curText(i)))>=0;
        if(ok) html+=wordSpans(curText(i), i, cls.concat('or-ok'), false);
        else html+='<span class="or-w or-ko">'+pretty(curText(i))+'</span> <span class="or-w or-fix">'+pretty(m.c)+'</span>';
      } else if(G.ans[i]!=null && norm(G.ans[i])!==norm(u.o)){
        html+='<span class="or-w or-ko">'+pretty(G.ans[i])+'</span> <span class="or-w or-back">'+pretty(u.o)+'</span>';
      } else html+=wordSpans(u.o, i, cls, false);
    });
    textEl.innerHTML=html;
  }
  function wordSpans(s, i, cls, tap){
    var attr=tap?' role="button" tabindex="0" data-u="'+i+'"':' data-u="'+i+'"';
    return s.split(' ').map(function(p){ return '<span class="'+cls.join(' ')+'"'+attr+'>'+pretty(p)+'</span>'; }).join(' ');
  }

  function edits(){
    var n=0; for(var k in G.ans) if(G.ans.hasOwnProperty(k)) n++; return n;
  }
  function updateCount(){
    var ms=G.text.m, shown=ms.filter(function(m){return isShown(m,G.level);}).length, hidden=ms.length-shown, s;
    if(G.level===1) s=plural(shown,'faute en rouge','fautes en rouge');
    else if(G.level===2) s=shown+' en rouge + '+plural(hidden,'cachée','cachées');
    else s=plural(ms.length,'faute cachée','fautes cachées')+' dans ce texte';
    var e=edits();
    countEl.innerHTML='<b>'+s+'</b>'+(e?'<span> · '+plural(e,'mot modifié','mots modifiés')+'</span>':'');
    hintBtn.textContent='Indice ('+(MAX_HINTS-G.hints)+')';
    hintBtn.disabled=G.checked || G.hints>=MAX_HINTS;
  }

  var toastTimer=null;
  function toast(msg, ms){
    clearTimeout(toastTimer);
    toastEl.innerHTML=msg||''; toastEl.classList.toggle('on', !!msg);
    if(msg && ms) toastTimer=setTimeout(function(){ toast(''); }, ms);
  }

  /* ----- feuille de saisie ----- */
  var editing=null, lastFocus=null;
  function openSheet(i){
    if(G.checked) return;
    editing=i; lastFocus=document.activeElement;
    var u=G.units[i];
    sheetOrig.innerHTML='Dans le texte : <b>'+pretty(u.k==='m'?u.w:u.o)+'</b>';
    input.value=curText(i).replace(/'/g,'’');
    resetBtn.hidden = G.ans[i]==null;
    sheetRoot.hidden=false;
    document.documentElement.classList.add('or-lock');
    markActive(i);
    try{ input.focus({preventScroll:true}); }catch(e){ input.focus(); }
    try{ var L=input.value.length; input.setSelectionRange(L,L); }catch(e){}
    fitSheet();
  }
  function closeSheet(){
    if(editing===null) return;
    editing=null; sheetRoot.hidden=true; sheet.style.bottom='';
    document.documentElement.classList.remove('or-lock');
    markActive(-1);
    try{ input.blur(); }catch(e){}
    if(lastFocus && lastFocus.focus && document.body.contains(lastFocus)) try{ lastFocus.focus({preventScroll:true}); }catch(e){}
  }
  function markActive(i){
    var els=textEl.querySelectorAll('.or-w');
    for(var k=0;k<els.length;k++) els[k].classList.toggle('or-act', +els[k].getAttribute('data-u')===i);
  }
  function commit(val){
    var i=editing, u=G.units[i], orig=u.k==='m'?u.w:u.o;
    val=String(val).replace(/\s+/g,' ').trim();
    if(!val || norm(val)===norm(orig)) delete G.ans[i]; else G.ans[i]=val.replace(/’/g,"'");
    closeSheet(); renderText(); updateCount();
    var el=textEl.querySelector('[data-u="'+i+'"]'); if(el) try{ el.focus({preventScroll:true}); }catch(e){}
  }
  /* garde la feuille au-dessus du clavier iOS */
  function fitSheet(){
    if(editing===null || !window.visualViewport) return;
    var vv=window.visualViewport, off=window.innerHeight-(vv.height+vv.offsetTop);
    sheet.style.bottom=Math.max(0,off)+'px';
  }
  if(window.visualViewport){ window.visualViewport.addEventListener('resize',fitSheet); window.visualViewport.addEventListener('scroll',fitSheet); }

  sheetForm.addEventListener('submit',function(e){ e.preventDefault(); commit(input.value); });
  resetBtn.addEventListener('click',function(){ var i=editing; delete G.ans[i]; closeSheet(); renderText(); updateCount(); });
  sheetRoot.addEventListener('click',function(e){ if(e.target.closest('[data-close]')) closeSheet(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && editing!==null) closeSheet(); });

  /* ----- vérification ----- */
  function check(){
    if(G.checked) return;
    var ms=G.text.m, found=0, wrongEdits=0;
    G.units.forEach(function(u,i){
      if(u.k==='m'){ if(accepted(ms[u.mi]).indexOf(norm(curText(i)))>=0) found++; }
      else if(u.k==='w' && G.ans[i]!=null && norm(G.ans[i])!==norm(u.o)) wrongEdits++;
    });
    var penalty = G.level>1 ? wrongEdits : 0;
    var all = found===ms.length;
    var score = Math.max(0, found + (all?BONUS:0) - penalty);
    var prev = ST.best[G.level], rec = prev==null || score>prev;
    if(rec){ ST.best[G.level]=score; saveStore(); }
    G.checked=true;
    renderText(); updateCount(); toast('');
    actionsEl.classList.add('is-done');

    /* texte corrigé, fautes surlignées */
    var corr='';
    G.units.forEach(function(u){
      if(u.k==='p') corr+=punct(u.s);
      else if(u.k==='m') corr+='<mark class="or-hl">'+pretty(u.o)+'</mark>';
      else corr+=pretty(u.o);
    });
    var rules=G.units.filter(function(u){return u.k==='m';}).map(function(u){
      var m=ms[u.mi], i=G.units.indexOf(u), ok=accepted(m).indexOf(norm(curText(i)))>=0;
      return '<li class="'+(ok?'is-ok':'is-ko')+'"><span class="or-ico" aria-hidden="true">'+(ok?'✓':'✗')+'</span>'+
        '<span><s>'+pretty(m.w)+'</s> → <b>'+pretty(m.c)+'</b><em>'+punct(m.r)+'</em></span></li>';
    }).join('');

    resultEl.innerHTML=
      '<div class="or-score">'+
        '<p class="or-label">Résultat</p>'+
        '<p class="or-big">'+found+'/'+ms.length+' <span>'+(ms.length>1?'fautes corrigées':'faute corrigée')+'</span></p>'+
        '<p class="or-pts">'+pts(score)+(all?' <span class="or-chip">+'+BONUS+' bonus sans faute</span>':'')+
          (penalty?' <span class="or-chip or-chip--ko">−'+penalty+' mot'+(penalty>1?'s':'')+' juste'+(penalty>1?'s':'')+' modifié'+(penalty>1?'s':'')+'</span>':'')+'</p>'+
        '<p class="or-rec">'+(rec?'Nouveau record pour ce niveau ! 🎉':'Record du niveau : '+pts(prev))+'</p>'+
        (all&&!penalty?'<p class="or-bravo">Sans faute, bravo !</p>':'')+
      '</div>'+
      '<div class="or-card"><p class="or-label">Le texte corrigé</p><p class="or-corr">'+corr+'</p></div>'+
      '<div class="or-card"><p class="or-label">Les règles</p><ul class="or-rules">'+rules+'</ul></div>'+
      '<div class="or-actions or-actions--end">'+
        '<button type="button" class="or-btn or-btn--dark" data-act="new">Nouveau texte</button>'+
        '<button type="button" class="or-btn or-btn--soft" data-act="level">Changer de niveau</button>'+
      '</div>';
    resultEl.hidden=false;
    try{ resultEl.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){}
  }

  /* ----- indice ----- */
  function hint(){
    if(G.checked || G.hints>=MAX_HINTS) return;
    var ms=G.text.m, cands=[];
    G.units.forEach(function(u,i){
      if(u.k!=='m') return;
      var m=ms[u.mi];
      if(accepted(m).indexOf(norm(curText(i)))>=0) return;
      cands.push({i:i, m:m, hidden:!isShown(m,G.level), untouched:G.ans[i]==null});
    });
    if(!cands.length){ toast('Tout semble corrigé : vérifiez !', 2500); return; }
    var hid=cands.filter(function(c){return c.hidden;});
    var pool=hid.length?hid:cands, fresh=pool.filter(function(c){return c.untouched;});
    if(fresh.length) pool=fresh;
    var c=pool[Math.floor(Math.random()*pool.length)];
    G.hints++; updateCount();
    var els=textEl.querySelectorAll('[data-u="'+c.i+'"]');
    for(var k=0;k<els.length;k++){ els[k].classList.remove('or-hint'); void els[k].offsetWidth; els[k].classList.add('or-hint'); }
    if(els[0]) try{ els[0].scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){}
    setTimeout(function(){ for(var k=0;k<els.length;k++) els[k].classList.remove('or-hint'); }, 2600);
    toast(c.hidden ? 'Regardez bien le mot qui clignote…' : 'Indice : '+punct(c.m.r), c.hidden?2600:6000);
  }

  /* ----- événements ----- */
  app.addEventListener('click',function(e){
    var lv=e.target.closest('[data-lv]');
    if(lv){ start(+lv.getAttribute('data-lv')); return; }
    var w=e.target.closest('[data-u].or-tap');
    if(w && G && !G.checked){ openSheet(+w.getAttribute('data-u')); return; }
    var a=e.target.closest('[data-act]');
    if(!a) return;
    var act=a.getAttribute('data-act');
    if(act==='check') check();
    else if(act==='hint') hint();
    else if(act==='new'){ start(G.level); try{ $('or-paper').scrollIntoView({behavior:'smooth', block:'start'}); }catch(err){} }
    else if(act==='level') showPick();
  });
  textEl.addEventListener('keydown',function(e){
    if(e.key!=='Enter' && e.key!==' ') return;
    var w=e.target.closest('[data-u].or-tap'); if(!w) return;
    e.preventDefault(); openSheet(+w.getAttribute('data-u'));
  });

  showPick();

  /* toujours revenir au choix du niveau quand on rouvre le jeu */
  document.addEventListener('gj:open',function(e){ if(e.detail==='orthographe'){ try{ showPick(); }catch(err){} } });
})();
